module.exports = __webpack_public_path__ + "img/platinum.b56a3201.svg";